<template>
  <div class="video detail-card collapsible-card">
    <div class="banner" @click="toggle(content)" :style="{
      'border-bottom': opened ? '1px solid #E4E7ED' : 'none'
    }">
      <div class="icon">
        <img src="@/assets/lessons/lesson/lesson-video-white.svg" />
      </div>
      <p class="align-left title regular"><span class="caps">Video&nbsp;{{index}}</span> - {{video.title}}</p>
      <img class="arrow" :class="{'opened' : opened }" src="@/assets/lessons/lesson/lesson-arrow-right.svg" />
    </div>
    <div class="content" ref="content" data-collapsed="true"> 
      <div class="padded">
        <p class="align-left body">{{video.subtitle}}</p>
        <p class="description-video">{{video.description}}</p>
        <p class="align-left caption">Duration: {{video.duration}}</p>
        <div class="player">
          <youtube :video-id="getVideoId(video.link)"></youtube>
        </div>
        <p class="align-left body">{{video.footer}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { getIdFromURL } from 'vue-youtube-embed'
  import collapsible from "@/mixins/collapsible"
  export default {
    name: 'Video',
    mixins: [collapsible],
    data () {
      return {
        opened: false
      }
    },
    props: {
      index: {
        type: Number
      },
      video: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    computed: {
      content () { return this.$refs.content }
    },
    methods: {
      getVideoId(link) {
        return getIdFromURL(link)
      },
      toggle (element) {
        if (this.opened) {
          this.collapseSection(element)
        } else {
          this.$emit('expanded')
          this.expandSection(element)
          element.setAttribute('data-collapsed', 'false')
        }
        this.opened = !this.opened
      }
    },
    watch: {
      shouldCollapse (newVal) {
        if (newVal) {
          this.collapseSection(this.content)
          this.opened = false
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "@/styles";  
  .description-video {
    text-align: left;
  }
  .body {
    width: 100%
  }
</style>